/*
 * @Description: 首页排行榜
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-11 14:37:10
 * @LastEditTime: 2019-05-08 11:04:07
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Homerank.css';
import cx from 'classnames'
import Link from '../Link'
import moment from 'moment'
// @ts-ignore
import loadGif from './loading.gif'
import { getBrandAndDataLength, getChampionJsonDay, getChampionJsonWeek, getChampionJsonMonth } from '../../controller';

const list = ['日榜', '周榜', '月榜']
const items = [
  [
    '排名',
    '品牌名称',
    '行业',
    'DB总值',
    '日涨跌幅',
    '传播度',
    '参与度',
    '好感度',
    '*(行业内)心智占有率'
  ],
  [
    '排名',
    '品牌名称',
    '行业',
    'DB总值',
    '周涨跌福',
    '波峰值',
    '波谷值',
    '*(行业内)心智占有率',
    '　　　*(行业内)　　　心智占有率涨跌',
    '周排名波动'
  ],
  [
    '排名',
    '品牌名称',
    '行业',
    'DB总值',
    '月涨跌幅',
    '波峰值',
    '波谷值',
    '*(行业内)心智占有率',
    '　　　*(行业内)　　　心智占有率涨跌',
    '月排名波动'

  ]
]

class Homerank extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      listIndex: 0,
      rankItems: [],
      time:null,
      brandCount:'',
      dataLength:'',
    }
    this.loadingShow = this.loadingShow.bind(this)
    this.changeJson = this.changeJson.bind(this)
    this.renderRank=this.renderRank.bind(this)
  }

  componentDidMount() {
    let time
    if(this.state.time==null){
			if(moment().format('a')=='pm'){
        time=`${moment().subtract(1,'days').format('YYYY-MM-DD')}`
      
      }else{
        time=`${moment().subtract(2,'days').format('YYYY-MM-DD')}`
      }
      this.setState({time})
    }
    this.getChampionJsonDay(time)
    this.getBrandAndDataNum()
  }
  getBrandAndDataNum=()=>{
    getBrandAndDataLength()
      .then(res => {
        if (!res) return
        this.setState({
          brandCount:res.brandLength,
          dataLength:res.dataLength,
        })
      })
  }
  getChampionJsonDay(bb) {
    this.setState({loading: true,rankItems:[]})
    let aa=bb||this.state.time

    const query = {
      statisDate: aa,
      num: 20
    }

    getChampionJsonDay(query)
      .then(res => {
        if (!res) return this.setState({
          loading: false 
        })
        
        if(this.state.listIndex==0){
          this.setState({
            loading: false,
            rankItems: res.rankItems
          })
        }
      })
  }
  getChampionJsonWeek() {
    this.setState({loading: true, rankItems:[]})
    let aa = moment(`${this.state.time}`).day(0).format('YYYY-MM-DD')

    getChampionJsonWeek({
      statisDate: aa,
      num: 20
    })
      .then(res => {
        if (!res) return this.setState({loading: false})
        
        if(this.state.listIndex==1){
          this.setState({
            loading: false,
            rankItems: res.rankItems
          })
        }
      })
  }
  getChampionJsonMonth() {
    this.setState({loading: true,rankItems:[]})
    let aa=moment(moment(`${this.state.time}`).format('YYYY-MM')).subtract(1,'days').format('YYYY-MM-DD')

    getChampionJsonMonth({
      statisDate: aa,
      num: 20
    })
      .then(res => {
        if (!res) return this.setState({loading: false})

        if(this.state.listIndex==2){
          this.setState({loading: false, rankItems: res.rankItems})
        }
      })
  }

  renderTbody=()=> {
    const tit = list[this.state.listIndex]
    const {rankItems, loading} = this.state

    if (tit == '日榜') {
      return (
        <tbody>
          {rankItems.map((item, index) => <tr key={index}>
            <th>{index + 1}</th>
            <td>
              <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
              <Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(item.name))}`}>{item.name}</Link>
            </td>
            <td>{item.industry}</td>
            <td>{parseFloat(item.db).toLocaleString()}</td>
            <td className={s.isUp}>{item.daily}
              <span className={s[item.dailyStyle]}></span>
            </td>
            <td>{item.spread}</td>
            <td>{item.participate}</td>
            <td>{item.favorability}</td>
            <td>{item.mind}</td>
          </tr>)}
        </tbody>
      )
    } else if (tit == '周榜') {
      return (
        <tbody>
          {rankItems.map((item, index) => <tr key={index}>
            <th>{index + 1}</th>
            <td>
              <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
              <Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(item.name))}`}>{item.name}</Link>
            </td>
            <td>{item.industry}</td>
            <td>{parseFloat(item.db).toLocaleString()}</td>
            <td className={s.isUp}>{item.daily}
              <span className={s[item.dailyStyle]}></span>
            </td>
            <td>{parseFloat(item.peak).toLocaleString()}</td>
            <td>{parseFloat(item.trough).toLocaleString()}</td>
            <td>{item.mind}</td>
            <td className={s.isUp}>{item.mindNum}
              <span className={s[item.mindStyle]}></span>
            </td>
            <td className={s.isUp}>{item.king}
              <span className={s[item.kingStyle]}></span>
            </td>
          </tr>)}
        </tbody>
      )
    } else {
      return (
        <tbody>
          {rankItems.map((item, index) => <tr key={index}>
            <th>{index + 1}</th>
            <td>
              <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
              <Link to={`/dashboard?brandName=${encodeURIComponent(decodeURIComponent(item.name))}`}>{item.name}</Link>
            </td>
            <td>{item.industry}</td>
            <td>{parseFloat(item.db).toLocaleString()}</td>
            <td className={s.isUp}>{item.daily}
              <span className={s[item.dailyStyle]}></span>
            </td>
            <td>{parseFloat(item.peak).toLocaleString()}</td>
            <td>{parseFloat(item.trough).toLocaleString()}</td>
            <td>{item.mind}</td>
            <td className={s.isUp}>{item.mindNum}
              <span className={s[item.mindStyle]}></span>
            </td>
            <td className={s.isUp}>{item.king}
              <span className={s[item.kingStyle]}></span>
            </td>
          </tr>)}
        </tbody>
      )
    }

  }
  changeJson = (index) => {
    const tit = list[index]
    this.setState({listIndex: index})
    if (tit == '日榜') {
      this.getChampionJsonDay()
    } else if (tit == '周榜') {
      this.getChampionJsonWeek()
    } else {
      this.getChampionJsonMonth()
    }
  }
  loadingShow = () => {
    return (
      <div className={s.loadingBox}>
        <img src={loadGif}/>
      </div>
    )
  }
  renderRank = () => {

    const{listIndex}=this.state
    return (
      <table cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            {items[listIndex].map((item, index) => <th key={index}>{item}</th>)}
          </tr>
        </thead>
        {this.renderTbody()}
      </table>
    )
  }

  render() {
    const {listIndex, rankItems, loading,brandCount,dataLength} = this.state
    const getTimeOut = function () {
      if (moment().format('a') == 'pm') {
        return <span className={s.timeOut}>{moment()
            .subtract(1, 'days')
            .format('YYYY-MM-DD')}</span>
      } else {
        return <span className={s.timeOut}>{moment()
            .subtract(2, 'days')
            .format('YYYY-MM-DD')}</span>
      }
    }
    return (
      <div className={s.root}>
        <div className={s.dbTable}>
          <ul className={s.dbBtn}>
            {list.map((item, index) => <li
              key={index}
              className={index == listIndex
              ? cx(s.dayBtn, s.ac)
              : s.dayBtn}
              onClick={() => {
              this.changeJson(index)
            }}>{item}</li>)}
          </ul>

          <span className={s.deadline}>数据截至时间：{getTimeOut()}
            24 时</span>
          <div className={s.dbrandNum}>
            <span className={s.timeOut}>已追踪品牌数：{brandCount} 个</span>
            <span className={ s.timeOut}>本日新增数据量：{dataLength} 条</span>
          </div>

          {loading?this.loadingShow():this.renderRank()}
          <span className={s.tabular}>*指该品牌在同行业所有调研品牌中，以DB总值计算的受众心智占有份额；当该品牌涉及多个行业时，只显示它在不同行业内心智占有率最高的数值，其它数值详见该品牌详情页。</span>
        </div>
        <div>
          <Link to='/top100' className={s.moreBtn}>查看TOP100完整榜单</Link>
        </div>
      </div>
    )
  }
}

export default withStyles(s)(Homerank);



// WEBPACK FOOTER //
// src/components/Homerank/Homerank.js